import { Row, Col, Button } from 'antd'
import { useSelector } from 'react-redux'
import useTranslation from '@/hooks/useTranslation'

import Edit from '@/components/svgs/Edit'
import FilesDisplay from '@/components/shared-components/form/FilesDisplay'
import { UeCountries } from "@/config/StatiMembriDell'UE"
import FileTabGreen from '@/components/shared-components/FileTabGreen'

const commonStyle = 'flex sm:block items-center justify-between gap-4'
const colStyle = 'sm:border-b border-[#DDD]'
const titleStyle =
  'text-[#6D6D6D] text-base sm:text-sm sm:mb-16 after:content-[":"]'
const descriptionStyle = 'text-black text-base font-semibold mb-0'

const StepDisplay = ({ current, toggleEdit }) => {
  const { t } = useTranslation()
  const { profile } = useSelector((state) => state.auth)

  const handleEditClick = () => {
    toggleEdit()
  }

  return (
    <div className='bg-[#FDFDFD] border border-[#DDD] rounded-xl p-16 sm:p-32 mb-8 relative'>
      {/* PERSONAL INFO */}
      {current === 0 && (
        <>
          <h3 className='sm:hidden text-lg font-bold mb-20'>
            Informazioni personali
          </h3>
          <Row>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} pb-8 sm:pb-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('First Name')}</h4>
              <p className={descriptionStyle}>{profile?.name}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} pb-8 sm:pb-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Last Name')}</h4>
              <p className={descriptionStyle}>{profile?.lname}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('form.email.label')}</h4>
              <p className={descriptionStyle}>{profile?.email}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('form.mobile.label')}</h4>
              <p className={descriptionStyle}>
                {profile?.mobile_number_code} {profile?.mobile_number}
              </p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Gender')}</h4>
              <p className={descriptionStyle}>
                {profile?.gender === 'M' ? t('Male') : t('Female')}
              </p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Nationality')}</h4>
              <p className={descriptionStyle}>{profile?.nationality}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Birth Date')}</h4>
              <p className={descriptionStyle}>{profile?.birth_date}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('form.password.label')}</h4>
              <p className={descriptionStyle}>************</p>
            </Col>
            <Col xs={24} sm={12} className={`pt-0 sm:pt-16 ${commonStyle}`}>
              <h4 className={titleStyle}>{t('Birth Place')}</h4>
              <p className={descriptionStyle}>{profile?.birth_place}</p>
            </Col>
          </Row>
        </>
      )}

      {/* ADDRESS */}
      {current === 1 && (
        <>
          <h3 className='sm:hidden text-lg font-bold mb-20'>Indirizzo</h3>
          <Row>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} pb-8 sm:pb-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Paese')}</h4>
              <p className={descriptionStyle}>{profile?.country}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} pb-8 sm:pb-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Province')}</h4>
              <p className={descriptionStyle}>{profile?.province}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('Città')}</h4>
              <p className={descriptionStyle}>{profile?.city}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              className={`${colStyle} py-4 sm:py-16 ${commonStyle}`}
            >
              <h4 className={titleStyle}>{t('nome della strada')}</h4>
              <p className={descriptionStyle}>{profile?.street}</p>
            </Col>
            <Col xs={24} sm={12} className={`pt-4 sm:pt-16 ${commonStyle}`}>
              <h4 className={titleStyle}>{t('Numero civico')}</h4>
              <p className={descriptionStyle}>{profile?.building_number}</p>
            </Col>
            <Col xs={24} sm={12} className={`pt-8 sm:pt-16 ${commonStyle}`}>
              <h4 className={titleStyle}>{t('Codice Postale')}</h4>
              <p className={descriptionStyle}>{profile?.zip_code}</p>
            </Col>
          </Row>
        </>
      )}

      {/* ATTACHMENTS */}
      {current === 2 && (
        <>
          <h3 className='sm:hidden text-lg font-bold mb-20'>Allegati</h3>
          <Row>
            <Col span={24} className={`${colStyle} pb-16`}>
              <h4 className={`${titleStyle} mb-8`}>
                {t('Documento di riconoscimento')}{' '}
                <span className='text-[#AAA]'>
                  {t(
                    "(Carta d'identita fronte e retro / Passaporto / Patente)"
                  )}
                </span>{' '}
                & {t('data di scadenza')}
              </h4>

              <Row gutter={[8, 8]}>
                <Col>
                  {
                    <FilesDisplay
                      arr={profile?.national_id_files}
                      path='path'
                      title='filename'
                      newTab={true}
                      marginTop='mt-0'
                    />
                  }
                </Col>
                <Col>
                  <p className={descriptionStyle}>{profile?.nid_expire_at}</p>
                </Col>
              </Row>
            </Col>

            {!UeCountries.includes(profile?.nationality) && (
              <Col span={24} className={`${colStyle} py-16`}>
                <h4 className={`${titleStyle} mb-8`}>
                  {t('Permesso di soggiorno')} & {t('data di scadenza')}
                </h4>

                <Row gutter={[8, 8]}>
                  <Col>
                    {
                      <FilesDisplay
                        arr={profile?.residence_files}
                        path='path'
                        title='filename'
                        newTab={true}
                        marginTop='mt-0'
                      />
                    }
                  </Col>
                  <Col>
                    <p className={descriptionStyle}>
                      {profile?.residence_expire_at}
                    </p>
                  </Col>
                </Row>
              </Col>
            )}

            <Col
              span={24}
              className={profile?.sign_at ? `${colStyle} py-16` : 'pt-16'}
            >
              <h4 className={`${titleStyle} mb-8`}>
                {t('Codice Fiscale / Tessera Sanitaria')}
              </h4>

              <Row gutter={[8, 8]}>
                <Col>
                  {
                    <FilesDisplay
                      arr={profile?.tax_code_health_card_files}
                      path='path'
                      title='filename'
                      newTab={true}
                      marginTop='mt-0'
                    />
                  }
                </Col>
                <Col>
                  <p className={descriptionStyle}>{profile?.serial_number}</p>
                </Col>
              </Row>
            </Col>

            {profile?.sign_at && (
              <Col span={24} className='pt-16'>
                <h4 className={titleStyle}>{t('Documento di firma')}</h4>

                <Row gutter={[8, 8]}>
                  <Col>
                    <div className='flex'>
                      <FileTabGreen
                        fileName={profile?.signature_document_name}
                        fileLink={profile?.signature_document}
                      />
                    </div>
                  </Col>
                  <Col>
                    <p className={descriptionStyle}>
                      {profile?.sign_at.split(' ')[0]}
                    </p>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </>
      )}

      <Button
        className='btn-green w-40 h-40 p-0 border-0 rounded-xl flex items-center justify-center absolute top-8 right-8 sm:top-16 sm:right-16'
        onClick={handleEditClick}
      >
        <Edit style={'w-24'} />
      </Button>
    </div>
  )
}

export default StepDisplay
